<template>
  <tr class="clickable">
    <td class="no_padding drag_drop"><span></span></td>
    <td class="no_padding">
      <input type="checkbox"
             :id="entity.id"
             :value="entity.id"
             :checked="isChecked"
             @click.stop
      />
      <label :for="entity.id" @click.stop v-translate>Vybrat</label>
    </td>
    <td data-th="Název" class="first_data" @click.stop="goToDetail($event, entity.id)"><strong>{{ entity.name }}</strong></td>
    <td data-th="Kanály">{{ entity.channels.map(channel => channel.name).join(', ') }}</td>
    <td class="no_padding edit">
      <div class="edit_inner">
        <a
            v-if="$_deleteActionAllowed"
            class="btn btn_action btn_delete"
            :title="'Smazat' | translate"
            @click.prevent.stop="emitDeleteChannelGroup">
          <translate class="translate">Smazat</translate>
        </a>
      </div>
    </td>
  </tr>
</template>

<script>

export default {
  name: 'AdvertisingProviderChannelGroupRow',
  mixins: [],
  props: {
    entity: Object,
    selectedEntities: Array,
  },
  data() {
    return {
      moduleName: 'advertisingProviders',
    }
  },
    methods: {
      goToDetail(e, id) {
        this.$router.push({name: 'advertisingProviderChannelGroupDetail', params: {id: id}})
      },
      emitDeleteChannelGroup() {
        this.$emit('deleteChannelGroup', this.entity.id)
      },
  },
  computed: {
    isChecked() {
      return this.selectedEntities.indexOf(String(this.entity.id)) > -1
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/advertisingProviders/detail/ChannelGroupRow.vue